export default "__VITE_ASSET__BXXKX3$___"